import {SearchQueryParams} from '../../models/search-query-params.model';

export namespace PolicyRegistryActions {
    export class GetListPage {
        static readonly type = 'PolicyRegistryActions.GetListPage';

        constructor(public params?: SearchQueryParams) {
        }
    }

    export class ClearListItems {
        static readonly type = 'PolicyRegistryActions.ClearListItems';
    }

    export class ClearList {
        static readonly type = 'PolicyRegistryActions.ClearList';
    }
}
